import { fromJS } from "immutable";

const initMenuData = {};
const initTreeData = {};

const initFilterMenuData = {

};
export function menuData(state = initMenuData, action) {
  switch (action.type) {
    case "MENU_FETCH_DATA_SUCCESS":
      return action.dataMenu;
    default:
      return state;
  }
}

export function treeData(state = initTreeData, action) {
  switch (action.type) {
    case "TREE_FETCH_DATA_SUCCESS":
      return action.dataTree;
    default:
      return state;
  }
}

export function userDetail(state = fromJS({}), action) {
  switch (action.type) {
    case "USER_FETCH_DETAIL_SUCCESS":
      return fromJS(action.detail);
    default:
      return state;
  }
}

export function filterDataMenu(state = initFilterMenuData, action) {
  switch (action.type) {
    case "FILTER_SET_MENU_NAME_SUCCESS":
      return state.set("filter", action.filter);
    case "FILTER_SET_PAGE_NO_SUCCESS":
      return state.set("pageNo", action.pageNo);
    case "FILTER_SET_PAGE_SIZE_SUCCESS":
      return state.set("pageSize", action.pageSize);
    default:
      return state;
  }
}
